const multiple = {
  questionsCnt: 6,
  resultsCnt: 3,
  optionsCnt: 3,
};

const mbti = {};

const weight = {};

const preset = { multiple, mbti, weight };

export default preset;
